import { useState } from 'react';
import { User, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Tooltip } from '../ui/Tooltip';
import { cn } from '../../lib/utils';
import { DropdownMenu } from '../ui/DropdownMenu';
import { UserSettingsDialog } from '../settings/UserSettingsDialog';

export function UserMenu() {
  const { user, logout } = useAuth();
  const [settingsOpen, setSettingsOpen] = useState(false);

  if (!user) return null;

  return (
    <>
      <DropdownMenu
        className="relative"
        align="end"
        trigger={
          <Tooltip content="User Menu" side="bottom">
            <button
              aria-label="User Menu"
              className={cn(
                'flex items-center justify-center p-2 transition-colors',
                'hover:bg-gray-100 dark:hover:bg-gray-800',
                'relative'
              )}
            >
              <div className="w-10 h-10 rounded-full bg-blue-600 dark:bg-blue-500 flex items-center justify-center pointer-events-none">
                <User className="w-6 h-6 text-white pointer-events-none" />
              </div>
            </button>
          </Tooltip>
        }
        items={[
          {
            label: user.name,
            icon: <User className="w-4 h-4" />,
            onClick: () => {},
            className: 'pointer-events-none font-medium',
          },
          {
            label: user.email,
            onClick: () => {},
            className: 'pointer-events-none text-xs text-gray-500 dark:text-gray-400',
          },
          ...user.roles.map((role) => ({
            label: role,
            onClick: () => {},
            className: 'pointer-events-none text-xs font-mono text-gray-600 dark:text-gray-400',
          })),
          {
            label: 'User Settings',
            icon: <Settings className="w-4 h-4" />,
            onClick: () => setSettingsOpen(true),
          },
          {
            label: 'Logout',
            icon: <LogOut className="w-4 h-4" />,
            onClick: () => logout(),
            className: 'text-red-600 dark:text-red-400',
          },
        ]}
      />

      <UserSettingsDialog open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
}


